import styled from "styled-components";
import {
  COLORS,
  responsive,
} from "../../../../../../../../styles/constants.style";

export const ProgramStatusResultWrapper = styled.div`
  margin: 19px 0px 39px 0px;
  ${responsive.MOBILE`
    margin: 16px 0px 0px 0px;   
  `}
  .form-header {
    display: flex;
    align-items: center;
    padding: 10px 16px;
    justify-content: space-between;
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }
  }
  .cell-created-date {
    min-width: 250px;
  }
  .cell-status {
    min-width: 200px;
  }
  .cell-form-date {
    min-width: 225px;
  }
  .cell-through-date {
    min-width: 225px;
  }
  .cell-createdby {
    min-widh: 225px;
  }
  .cell-notes {
    min-width: 300px;
  }
`;
